import { MediaErrorName } from 'models/media-error-name.enum';
import { Messages } from 'primereact/messages';
import { PropsWithChildren, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface ComponentProps {
  context: 'camera' | 'microphone';
  error: DOMException | null;
}

const MediaErrorMessage = ({ context, error }: PropsWithChildren<ComponentProps>) => {
  const messagesRef = useRef<Messages>(null);

  const { t } = useTranslation();

  useEffect(() => {
    if (messagesRef.current) {
      messagesRef.current.clear();

      if (error?.name) {
        switch (error.name) {
          case MediaErrorName.ABORT_ERROR: {
            messagesRef.current.show({ severity: 'error', detail: t('Error occurred which prevented from being used', { context }), closable: true, sticky: true });
            break;
          }
          case MediaErrorName.NOT_FOUND_ERROR: {
            messagesRef.current.show({ severity: 'warn', detail: t('Context not found', { context }), closable: true, sticky: true });
            break;
          }
          case MediaErrorName.NOT_READABLE_ERROR: {
            messagesRef.current.show({ severity: 'error', detail: t('Error occurred at the operating system', { context }), closable: true, sticky: true });
            break;
          }
          case MediaErrorName.OVERCONSTRAINED_ERROR: {
            messagesRef.current.show({ severity: 'error', detail: error.message, closable: true, sticky: true });
            break;
          }
          case MediaErrorName.NOT_ALLOWED_ERROR:
          case MediaErrorName.SECURITY_ERROR:
          case MediaErrorName.TYPE_ERROR: {
            messagesRef.current.show({ severity: 'error', detail: t('Your browser cannot access', { context }), closable: true, sticky: true });
            break;
          }
          default: {
            messagesRef.current.show({ severity: 'warn', detail: error.message ?? error.name, closable: true, sticky: true });
          }
        }
      }
    }
  }, [ context, error ]);

  return (
    <Messages ref={messagesRef}/>
  );
};

export default MediaErrorMessage;